import { parsePhoneNumber } from 'libphonenumber-js';
import moment from 'moment';
import { CorporatePaymentMode, ERROR_MESSAGE, FORM_PHASE, PAYMENT_MODE } from '../config/constant';

const units = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  
  export function convertNumberToWords(num) {
    if (num === 0) return 'Zero Rupees Only';
  
    let words = '';
  
    // Break the number into Crore, Lakh, Thousand, Hundred, Tens, and Units
    const crore = Math.floor(num / 10000000);
    const lakh = Math.floor((num % 10000000) / 100000);
    const thousand = Math.floor((num % 100000) / 1000);
    const hundred = Math.floor((num % 1000) / 100);
    const remainder = num % 100;
  
    if (crore > 0) {
      words += convertHundreds(crore) + ' Crore ';
    }
  
    if (lakh > 0) {
      words += convertHundreds(lakh) + ' Lakh ';
    }
  
    if (thousand > 0) {
      words += convertHundreds(thousand) + ' Thousand ';
    }
  
    if (hundred > 0) {
      words += convertHundreds(hundred) + ' Hundred ';
    }
  
    if (remainder > 0) {
      words += convertHundreds(remainder);
    }
  
    return words.trim() + ' Rupees Only'; // Add "Rupees Only" at the end
  }
  
  // Helper function to convert numbers below 1000 to words
 function convertHundreds(num) {
    let result = '';
    if (num > 99) {
      result += units[Math.floor(num / 100)] + ' Hundred ';
      num = num % 100;
    }
    if (num > 19) {
      result += tens[Math.floor(num / 10)] + ' ';
      num = num % 10;
    }
    if (num > 0) {
      result += units[num] + ' ';
    }
    return result.trim();
  }

export function formatNumberIndian(amount) {
  if (amount === null || amount === undefined) return '0';

  const num = Number(amount);
  if (Number.isNaN(num)) return '0';

  return new Intl.NumberFormat('en-IN').format(num);
}

export const checkFileSize = (file, sizeInMB) => {
  let filesize = file?.size / 1000000;
  let response = false;
  if (filesize && filesize > sizeInMB) {
    response = false;
  } else {
    response = true;
  }
  return response;
};

export const base64ToImage = (base64, fileName = 'image.jpeg') => {
  // Convert Base64 to binary data
  const byteString = atob(base64.split(',')[1]);

  // Create an ArrayBuffer and view it as a Uint8Array
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uintArray = new Uint8Array(arrayBuffer);

  // Fill the array with binary data
  for (let i = 0; i < byteString.length; i++) {
    uintArray[i] = byteString.charCodeAt(i);
  }

  // Create a Blob from the binary data
  const blob = new Blob([uintArray], { type: 'image/jpeg' });

  // Create a File object from the Blob (optional)
  const file = new File([blob], fileName, { type: 'image/jpeg' });

  // Generate a URL for the file or blob
  const url = URL.createObjectURL(file);

  // Now you can set the URL as the src of an image
  const img = document.createElement('img');
  img.src = url;
  document.body.appendChild(img); // Append image to body (or any other element)
  
  return file;
}
export const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

export const onlyNumber  = (value) => {
  const regex = /^[0-9]+$/;
   return (value && regex.test(value)) 
}

export const removeBlobImages = () => {
  const images = document.querySelectorAll('img');
  images.forEach((img) => {
    if (img.src.startsWith('blob:')) {
      img.remove();
    }
  });
}


export const getTotalYears = (dateValue) => {
  if (!dateValue) return 0;

  const birthDate = moment(dateValue, "YYYY/MM/DD");
  if (!birthDate.isValid()) return 0;

  const today = moment();
  const totalYears = today.diff(birthDate, "years");

  return totalYears;
};
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getPanNumber = (selectedName, applicantData) => {
  if (!selectedName || !applicantData) return "";

  for (let i = 1; i <= applicantData.noOfApplicants; i++) {
    const applicantKey = `applicant${i}`;
    const applicant = applicantData[applicantKey];

    if (applicant?.personalDetails) {
      const firstName = applicant.personalDetails.firstName?.trim();
      const lastName = applicant.personalDetails.lastName?.trim();
      const fullName = `${firstName} ${lastName}`.trim();

      if (fullName === selectedName) {
        return applicant?.contactDetails?.panNumber || "";
      }
    }
  }
  return "Applicant not found";
};

export const isValidPhoneNumberWithRules = (countryCode, number) => {
  if (!number || !countryCode) return false;

  try {
    const parsedNumber = parsePhoneNumber(`${countryCode}${number}`);
    const numericOnly = number.replace(/\D/g, "");

    if (countryCode === "+91" && numericOnly.length !== 10) return false;

    return parsedNumber?.isValid();
  } catch {
    return false;
  }
};

export const getLastStep = (lastStep = 0, activeStep = 0) => {
  return Math.max(Number(lastStep) || 0, Number(activeStep) || 0);
};

export const getErrorMessage = (error) => {
  const message = error?.errors?.message;

  if (Array.isArray(message)) return message.join("\n");
  if (typeof message === "string") return message;

  return ERROR_MESSAGE;
};
// utils/paymentHandler.js

export const handlePayment = (mode) => {
  if (!mode) return null;

  switch (mode) {
    case CorporatePaymentMode.GATEWAY:
      return PAYMENT_MODE.GATEWAY;

    case CorporatePaymentMode.OFFLINE:
      return PAYMENT_MODE.OFFLINE;

    default:
      return "N/A";
  }
};

export const toTitleCase = (str) =>
  str?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) || "N/A";


export const checkIsMasked = (value)  => {
  return !!value && /^[*]+$/.test(value);
};

export const getCurrentFormPhase = (str) => str === FORM_PHASE.VOUCHER ? 'Voucher' : 'EOI';